import { useUserGroups } from './useUserGroups';
import {
  useGetSellerByHandle,
  useGetSellerByStateKey,
} from '../api/lending/lapiHooks';
import { getUserRoles } from '../utils/sellerUserRoles';

/**
 * Common seller identity properties for Amplitude click events fired from the
 * dashboard (seller_id + seller_segment + user_role). Unlike the page-view
 * tracker there's no loading gate — a click fires immediately with whatever has
 * resolved, so all fields are best-effort (seller_id is undefined until the
 * by-handle lookup settles, seller_segment until the by-state-key query does).
 * seller_id lives on the by-handle endpoint, so chain the handle from
 * by-state-key into it, matching useTrackSellerDashboardPageView.
 */
export const useSellerTrackingProperties = () => {
  const { groups } = useUserGroups();
  const { seller: sellerByStateKey } = useGetSellerByStateKey();
  const { seller: sellerByHandle } = useGetSellerByHandle(
    sellerByStateKey?.data.handle,
  );

  return {
    seller_id: sellerByHandle?.seller_id,
    seller_segment: sellerByStateKey?.data.seller_type,
    user_role: getUserRoles(groups),
  };
};
